export const SafeAreaBottomPadding = () => null;
